import Breadcrumbs from '@mui/material/Breadcrumbs';
import Stack from '@mui/material/Stack';

type BreadcrumbsProps = {
  separator: string | JSX.Element;
  breadcrumbs: JSX.Element[];
  ariaLabel?: string;
};

export default function CustomSeparator({
  separator,
  breadcrumbs,
  ariaLabel = 'breadcrumb',
}: BreadcrumbsProps) {
  return (
    <Stack spacing={2}>
      <Breadcrumbs
        separator={separator}
        aria-label={ariaLabel}
        sx={{
          my: 2,
          '.MuiBreadcrumbs-separator': {
            mx: 0.5,
          },
        }}
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}
